import { render, staticRenderFns } from "./ArquivoCiha.vue?vue&type=template&id=698c223c&"
import script from "./ArquivoCiha.vue?vue&type=script&lang=js&"
export * from "./ArquivoCiha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports